import { reactive } from 'vue';

/**
 * The B2B pricing dialog is mounted once in App.vue and opened from anywhere:
 * a car card, the car detail page, or in future any other surface. A tiny
 * reactive module is enough here; the public site does not use Pinia.
 */
export const b2bModal = reactive({
  open: false,
  vehicle: null,
  source: 'other',

  show(vehicle = null, source = 'other') {
    this.vehicle = vehicle;
    this.source = source;
    this.open = true;
  },

  hide() {
    this.open = false;
    this.vehicle = null;
    this.source = 'other';
  },
});
